import { render, staticRenderFns } from "./AppDetail.vue?vue&type=template&id=00214342&scoped=true&"
import script from "./AppDetail.vue?vue&type=script&lang=js&"
export * from "./AppDetail.vue?vue&type=script&lang=js&"
import style0 from "./AppDetail.vue?vue&type=style&index=0&id=00214342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00214342",
  null
  
)

export default component.exports